/**
 * Character-level experience table (curva "Estándar", cap de temporada = nivel 50).
 * Index = level, value = EXP needed to advance FROM that level to the next.
 * Números redondos calibrados a las recompensas de mobs (comunes ~150 XP). Total a 50 ≈ 9,64M XP:
 * grind temprano suave y cola pesada (50 = logro de temporada). Distinta de la curva OSRS de skills
 * (`shared/data/skills.ts`). Extensión futura: subir MAX_LEVEL y agregar filas a mano.
 */

export const MAX_LEVEL = 50;

/** EXP required to go from level N to level N+1 */
export const EXP_TABLE: number[] = [
  0,           // 0 (unused)
  400,         // 1
  650,         // 2
  1000,        // 3
  1600,        // 4
  2500,        // 5
  3400,        // 6
  4500,        // 7
  5800,        // 8
  7600,        // 9
  10000,       // 10
  12000,       // 11
  15000,       // 12
  18000,       // 13
  21000,       // 14
  25000,       // 15
  30000,       // 16
  36000,       // 17
  42000,       // 18
  48000,       // 19
  55000,       // 20
  62000,       // 21
  70000,       // 22
  79000,       // 23
  89000,       // 24
  100000,      // 25
  110000,      // 26
  125000,      // 27
  140000,      // 28
  150000,      // 29
  160000,      // 30
  175000,      // 31
  190000,      // 32
  210000,      // 33
  230000,      // 34
  250000,      // 35
  280000,      // 36
  310000,      // 37
  340000,      // 38
  370000,      // 39
  400000,      // 40
  430000,      // 41
  470000,      // 42
  510000,      // 43
  550000,      // 44
  600000,      // 45
  650000,      // 46
  700000,      // 47
  750000,      // 48
  800000,      // 49
];

/**
 * Get EXP needed to go from `level` to `level + 1`.
 * Returns Infinity at max level.
 */
export function getExpForNextLevel(level: number): number {
  if (level >= MAX_LEVEL) return Infinity;
  return EXP_TABLE[level] ?? Infinity;
}

/**
 * Calculate level and remaining exp from total accumulated exp.
 * Returns { level, currentExp, expForNext }
 */
export function getLevelFromTotalExp(totalExp: number): { level: number; currentExp: number; expForNext: number } {
  let remaining = totalExp;
  let level = 1;

  while (level < MAX_LEVEL) {
    const needed = EXP_TABLE[level] ?? Infinity;
    if (remaining < needed) break;
    remaining -= needed;
    level++;
  }

  return {
    level,
    currentExp: remaining,
    expForNext: getExpForNextLevel(level),
  };
}
